import gql from "graphql-tag";

export default gql`
  mutation setAccountGroups($input: SetAccountGroupsInput!) {
    setAccountGroups(input: $input) {
      account {
        _id
        groups(first: 100) {
          nodes {
            _id
            name
            slug
            permissions
          }
        }
      }
    }
  }
`;
